

import * as React from 'react';
import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';
import TextareaAutosize from '@mui/material/TextareaAutosize'; // Import TextareaAutosize
import { useState } from 'react';
import { useEffect } from 'react';
import { TextField } from '@mui/material';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setQuestionAnswerList } from '../../system/redux/reducers/surveyReducer';

export default function SurveyDynamicCheckBox(props) {
    const dispatch = useDispatch();
    const [question, setQuestion] = useState(props.question);
    const [optionsList, setOptionsList] = useState(question.optionList);
    console.log(props);

    const [state, setState] = useState({});
    const [remarks, setRemarks] = useState({}); // State to store remarks
    const [val, setval] = useState();

    const handleChange = (event) => {
        //debugger;
        const { name, checked } = event.target;
        const currDynamicOptionId = event.target.getAttribute("dynamic-option-id");

        // If maxAnswerAttempt is -1 or not defined, allow selecting any number of checkboxes
        if (question.maxAnswerAllowed === -1 || question.maxAnswerAllowed === undefined) {
            setState({
                ...state,
                [currDynamicOptionId]: checked,
            });
        } else {
            // Otherwise, check the number of currently selected checkboxes
            const selectedOptionsCount = Object.values(state).filter(value => value).length;
    
            // If the maximum limit has not been reached or the checkbox is being unchecked
            if (selectedOptionsCount < question.maxAnswerAllowed || !checked) {
                setState({
                    ...state,
                    [currDynamicOptionId]: checked,
                });
            }
        }

        if (checked) {
            // If the checkbox is checked, set the remark as an empty string
            setRemarks({
                ...remarks,
                [currDynamicOptionId]: '',
            });
        } else {
            // If the checkbox is unchecked, remove the remark
            const { [currDynamicOptionId]: removed, ...newRemarks } = remarks;
            setRemarks(newRemarks);
        }
        // Call handleSubmit here
    };

    useEffect(() => {
        handleSubmit();
    }, [remarks])

    const handleSubmit = () => {
        //debugger;
        // Pass the IDs, texts, and remarks of the selected checkboxes to the parent component
        const selectedOptions = optionsList.filter(option => state[option.dynamicOptionId]);

        var payload = {
            id: question.id
        };

        if(selectedOptions && selectedOptions?.length > 0){
            payload = {
                id: question.id,
                answerList: selectedOptions.map(option => ({
                    dynamicOptionId: option.dynamicOptionId,
                    questionOptionId: option.id,
                    answerDescription: option.name,
                    remark: remarks[option.dynamicOptionId] ? remarks[option.dynamicOptionId] : '' // Use the remark from state or an empty string if it doesn't exist
                }))
            };
        }

        console.log(payload);
        dispatch(setQuestionAnswerList(payload));
    };

    const handleRemarkChange = (event) => {
        //debugger
        const { name, value } = event.target;
        const currDynamicOptionId = event.target.getAttribute("dynamic-option-id");

        setRemarks((prev) => ({
            ...prev,
            [currDynamicOptionId]: value,
        }));
    };

    return (
        <Box>
            <FormControl>
                <FormGroup>
                    {optionsList.map((option, index, optionsArray) => (
                        <div key={option.dynamicOptionId}>
                            <input type='hidden' id={"question-id-" + question.id + "-option-id-" + option.id} className={"question-id-" + question.id + "-option-id-" + option.id} name={"questionList[" + question.questionSequenceNo + "].answerList[" + index + "].questionOptionId"} value={option.id} />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        id={"question-id-" + question.id + "-option-id-" + option.id + "-dynamic-option-id-" + option.dynamicOptionId}
                                        className={"question-id-" + question.id + "-option-id-" + option.id + "-dynamic-option-id-" + option.dynamicOptionId}
                                        name={"questionList[" + question.questionSequenceNo + "].answerList[" + index + "].dynamicOptionId"}
                                        checked={state[option.dynamicOptionId] || false}
                                        onChange={handleChange}
                                        inputProps={{'dynamic-option-id': option.dynamicOptionId}} // Set the 'dynamic-option-id' attribute to identify the option
                                    />
                                }
                                label={option.name}
                            />
                            {option.showRemark && state[option.dynamicOptionId] && (
                                <TextField
                                    id={"question-id-" + question.id + "-option-id-" + option.id + "-dynamic-option-id-" + option.dynamicOptionId + ".remark"}
                                    className={"question-id-" + question.id + "-option-id-" + option.id + "-dynamic-option-id-" + option.dynamicOptionId + ".remark"}
                                    name={"questionList[" + question.questionSequenceNo + "].answerList[" + index + "].remark"}
                                    inputProps={{'dynamic-option-id': option.dynamicOptionId}} // Set the 'dynamic-option-id' attribute to identify the remarks
                                    label="Remark"
                                    variant="outlined"
                                    value={remarks[option.dynamicOptionId] || ''}
                                    onChange={handleRemarkChange}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    style={{ marginTop: '8px' }}
                                />
                            )}
                        </div>
                    ))}
                </FormGroup>
            </FormControl>
        </Box>
    );
}
